import "./Banner.scss";
const Banner = () => {
    return (<div className="hero-banner"><div className="content">
        <div className="text-content">
        <h1>CONNECT</h1>
        <p>Adding Green to your Life.
        <p>Bringing growth to agriculture.</p>
        </p>
        <div className="ctas">
            <div className="banner-cta">Read More</div>
            <div className="banner-cta v2">Shop Now</div>
        </div>
        </div>
        </div>
        </div>);
};
export default Banner;
